import { configureStore } from "@reduxjs/toolkit";
import windowReducer from "./window-slice";
import { reducer as indexedDBReducer } from "./indexed-db-slice";
import fileExplorerReducer from "./file-explorer-slice";
import { directoryReducer } from "./directory-slice";
import applicationsReducer from "./applications-slice";
import authReducer from "./auth.slice";
import userSettingsReducer from "./user-settings.slice";

export const store = configureStore({
    reducer: {
        window: windowReducer,
        indexedDB: indexedDBReducer,
        fileExplorer: fileExplorerReducer,
        directory: directoryReducer,
        applications: applicationsReducer,
        auth: authReducer,
        userSettings: userSettingsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
